export const CONCEPT2_OAUTH_MESSAGE_TYPE = 'glyyd:concept2-oauth';

export type Concept2OAuthStatus = 'connected' | 'error';

export interface Concept2OAuthResult {
  status: Concept2OAuthStatus;
  reason?: string | null;
}

export function openConcept2OAuthPopup(url: string): Window | null {
  const width = 520;
  const height = 720;
  const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
  const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);

  return window.open(
    url,
    'glyyd-concept2-oauth',
    `popup=yes,width=${width},height=${height},left=${left},top=${top}`
  );
}

export function publishConcept2OAuthResult(result: Concept2OAuthResult): boolean {
  if (!window.opener || window.opener.closed) {
    return false;
  }

  window.opener.postMessage(
    {
      type: CONCEPT2_OAUTH_MESSAGE_TYPE,
      status: result.status,
      reason: result.reason ?? null,
    },
    window.location.origin
  );
  window.close();
  return true;
}

export function parseConcept2OAuthMessage(data: unknown): Concept2OAuthResult | null {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const message = data as Record<string, unknown>;
  if (message.type !== CONCEPT2_OAUTH_MESSAGE_TYPE) {
    return null;
  }

  if (message.status !== 'connected' && message.status !== 'error') {
    return null;
  }

  return {
    status: message.status,
    reason: typeof message.reason === 'string' ? message.reason : null,
  };
}
